import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const ResistanceSummary = ({ surveyData }) => {
  const resistanceManagement = surveyData?.resistanceManagement;

  if (!resistanceManagement) return <h5 className="text-bold">No resistance management selected</h5>

  const formatLabel = (label = '') => {
    if (!label) return '';
    const formatted = label
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase())
      .trim();
    return formatted.replace(/\bGps\b/g, 'GPS');
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'inUse':
        return 'In Use';
      case 'futureUse':
        return 'Future Use';
      case 'notUsed':
        return 'Not Used';
      default:
        return 'N/A';
    }
  };

  const hasAnswers = (section = {}) => {
    if (!section || typeof section !== 'object') return false;
    return Object.values(section).some(item => 
      item && typeof item === 'object' && item.status
    );
  };

  const renderTableRows = (section = {}) => {
    if (!section || typeof section !== 'object') return null;

    return Object.entries(section).map(([key, item = {}]) => (
      <tr key={key}>
        <td>{formatLabel(key)}</td>
        <td>{getStatusLabel(item?.status)}</td>
        <td>{item?.notes ?? '-'}</td>
      </tr>
    ));
  };

  return (
    <>
      {Object.entries(resistanceManagement ?? {}).map(([sectionKey, sectionValue]) => {
        if (!sectionValue || typeof sectionValue !== 'object') return null;

        return (
          <div className="mb-5" key={sectionKey}>
            <h4 className="fw-bolder text-decoration-underline mb-3">{formatLabel(sectionKey)}</h4>
            {hasAnswers(sectionValue) ? (
              <div className="table-responsive">
                <table className="table table-bordered table-hover">
                  <thead className="table-light">
                    <tr>
                      <th scope="col">Question</th>
                      <th scope="col">Status</th>
                      <th scope="col">Notes</th>
                    </tr>
                  </thead>
                  <tbody>{renderTableRows(sectionValue)}</tbody>
                </table>
              </div>
            ) : (
              <h5 className="text-bold">No resistance management selected</h5>
            )}
          </div>
        );
      })}
    </>
  );
};

export default ResistanceSummary;